import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import CommonSection from "../shared/CommonSection";
import "./../styles/tour-packages.css";
import emailjs from "emailjs-com";
import Newsletter from "../shared/Newsletter";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';


import tour1 from "./../assets/images/short-tour2.jpg";
import tour2 from "./../assets/images/bikaner.jpg";
import tour3 from "./../assets/images/udaipur.jpg";
import tour4 from "./../assets/images/ajmer.jpg";
import tour5 from "./../assets/images/short-tour6.jpg";
import tour6 from "./../assets/images/jaisalmer.jpg";
import tour7 from "./../assets/images/bundi.jpg";
import tour8 from "./../assets/images/ranakpur.jpg";
import tour9 from "./../assets/images/barmer.jpg";
import tour10 from "./../assets/images/shekhawati.jpg";
import tour11 from "./../assets/images/dungarpur.jpg";
import tour12 from "./../assets/images/bharatpur.jpg";
import tour13 from "./../assets/images/karauli.jpg";
import tour14 from "./../assets/images/jhalawar.jpg";
import tour15 from "./../assets/images/dholpur.jpg";
import tour16 from "./../assets/images/chittogarh.jpg";
import tour17 from "./../assets/images/kumbhalpur.jpg";
import tour18 from "./../assets/images/bhilwara.jpg";
import tour19 from "./../assets/images/mountabu.jpg";
import tour20 from "./../assets/images/jodhpur.jpg";

const Destinations = () => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isFormOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    fromDate: "",
    destination: "",
    pickFrom: "Delhi", // Set the default value to "Delhi"
    numberOfPeople: 0,
  });

  // Your emailjs service parameters (replace with your actual service details)
  const serviceID = "service_2459xbb";
  const templateID = "template_58945jj";
  const userID = "mRKco-Lkgq2hUda_Q";

  const tourData = [
    {
      name: "Jaipur",
      category: "Deluxe Services",
      capacity: "Seating Capacity: 5 + Driver",
      luggage: "Luggage: 2 Large Suitcases + 3 Small Bags",
      image: tour1,
    },
    {
      name: "Bikaner",
      category: "Premium Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour2,
    },
    {
      name: "Udaipur",
      category: "Premium Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour3,
    },
    {
      name: "Ajmer",
      category: "Premium Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour4,
    },
    {
      name: "Ranthambore",
      category: "Budget Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour5,
    },
    {
      name: "Jaisalmer",
      category: "Budget Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour6,
    },
    {
      name: "Bundi",
      category: "Small Luxury Passenger Services",
      capacity: "Seating Capacity: 9 + Driver",
      luggage: "Luggage: 5 Large Suitcases + 3 Small Bags",
      image: tour7,
    },
    {
      name: "Ranakpur",
      category: "Small Luxury Passenger Services",
      capacity: "Seating Capacity: 18 + Driver",
      luggage: "Luggage: 13 Standard-sized Suitcases",
      image: tour8,
    },
    {
      name: "Barmer",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour9,
    },
    {
      name: "Shekhawati",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour10,
    },
    {
      name: "Dungarpur",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour11,
    },
    {
      name: "Bharatpur",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour12,
    },
    {
      name: "Karauli",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour13,
    },
    {
      name: "Jhalawpur",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour14,
    },
    {
      name: "Dholpur",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour15,
    },
    {
      name: "Chittorgarh",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour16,
    },
    {
      name: "Kumbhalpur",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour17,
    },
    {
      name: "Bhilwara",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour18,
    },
    {
      name: "Mount Abu",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour19,
    },
    {
      name: "Jodhpur",
      category: "Luxury Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour20,
    },
  ];

  const filteredtours = tourData.filter(
    (tour) => tour.category === selectedCategory || selectedCategory === ""
  );
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 6;

  // const indexOfLasttour = currentPage * itemsPerPage;
  // const indexOfFirsttour = indexOfLasttour - itemsPerPage;
  // const currenttours = filteredtours.slice(indexOfFirsttour, indexOfLasttour);

  const openForm = () => {
    setFormOpen(true);
  };

  const closeForm = () => {
    setFormOpen(false);
    // Reset the form when closing
    setFormData({
      name: "",
      fromDate: "",
      destination: "",
      pickFrom: "Delhi",
      numberOfPeople: 0,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "fromDate") {
      const today = new Date().toISOString().split("T")[0];
      if (value < today) {
        return;
      }
    }

    if (name === "numberOfPeople") {
      if (value < 0) {
        return;
      }
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(serviceID, templateID, formData, userID)
      .then((response) => {
        console.log("Email sent successfully:", response);
        closeForm();
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
      });
  };
  const navigate = useNavigate();
  const navigateTotourDetails = (tourName) => {
    navigate(`/destinations/Rajasthan/${tourName.split(" ").join("-").toLowerCase()}`);
  };
  return (
    <>
      <Helmet>
        <title>Destinations in India | Book Your Tour Today! | The Rustic Paths</title>
        <meta
          name="description"
          content="Explore the best destinations in India with our tours. We offer a variety of packages to suit your budget and interests. Book your tour today!"
        />
      </Helmet>

      <CommonSection title={"Our Destinations"} />

      <section className="tour-rental-section py-12">
        <Container>
          <Row>
            <div className="container mx-auto px-4">

              <Row>
                {filteredtours.map((tour, index) => (
                  <Col key={index} sm="12" md="6" lg="4" className="mb-4 pt-5">
                    <div className="tour__option bg-white p-6 rounded-lg shadow-lg flex relative">
                      <div className="w-1/2">
                        <img
                          src={tour.image}
                          alt={tour.name}
                          className="w-full h-auto"
                        />
                      </div>
                      <div className="text w-1/2">
                        <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center border-b pb-2">
                          {tour.name}
                        </h3>
                        {/* <div className="text-center text-gray-600 mb-4">
                        <strong>Category:</strong> {tour.category}
                      </div>
                      <div className="text-center text-gray-600 mb-4">
                        <strong>Seating Capacity:</strong> {tour.capacity}
                      </div>
                      <div className="text-center mb-4">
                        <strong>Luggage Capacity:</strong> {tour.luggage}
                      </div>  */}
                        <div className="text-center ">
                          <button
                            onClick={() => {
                              navigateTotourDetails(tour.name); // Navigate to tour details page
                            }}
                            className="btn primary__btn bg-blue-500 text-white px-4 py-3 rounded-full hover.bg-blue-600 mb-4"
                          >
                            Know More
                          </button>
                        </div>
                      </div>
                      <div className="blur-border"></div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            {/* <div className="pagination">
          {filteredtours.length > itemsPerPage &&
            Array(Math.ceil(filteredtours.length / itemsPerPage))
              .fill()
              .map((_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  className={`page-button ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  {index + 1}
                </button>
              ))}
        </div> */}
            <Col lg="12">
              {/* Add the ElfSight testimonial widget div */}
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
          </Row>
        </Container>

        {isFormOpen && (
          <div className="form-popup">
            <form onSubmit={handleSubmit}>
              <label>
                Name:
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Email:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                From Date:
                <input
                  type="date"
                  name="fromDate"
                  value={formData.fromDate}
                  onChange={handleInputChange}
                  min={new Date().toISOString().split("T")[0]}
                />
              </label>
              <label>
                Destination:
                <input
                  type="text"
                  name="destination"
                  value={formData.destination}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Pick From:
                <input
                  type="text"
                  name="pickFrom"
                  value={formData.pickFrom}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Number of People:
                <input
                  type="number"
                  name="numberOfPeople"
                  value={formData.numberOfPeople}
                  onChange={handleInputChange}
                  min="0"
                />
              </label>
              <button type="submit">Submit</button>
              <button type="close" onClick={closeForm}>
                Close
              </button>
            </form>
          </div>
        )}
      </section>
      <Newsletter />
    </>
  );
};

export default Destinations;
